import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MarketingLayout } from "../components/MarketingLayout";
import api from "../lib/api";

export default function TemplatesPage() {
  const [templates, setTemplates] = useState([]);
  useEffect(() => {
    api.get("/templates").then((r) => setTemplates(r.data?.templates || [])).catch(() => {});
  }, []);

  return (
    <MarketingLayout>
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="marquee-tag mb-4">// TEMPLATES</div>
        <h1 className="font-display font-black type-title-lg tracking-tighter mb-4">START FROM A TEMPLATE.</h1>
        <p className="type-lead text-ink-muted mb-12 max-w-xl">Pre-configured tone, length, and structure — so you ship faster.</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {templates.map((t) => (
            <div key={t.id} className="brutal-card p-6" style={{ borderTopColor: t.accent || "var(--accent)", borderTopWidth: 4 }}>
              <span className="text-2xl">{t.emoji}</span>
              <h2 className="font-display font-black type-subheading mt-3">{t.label}</h2>
              <p className="text-sm text-ink-muted mt-2 leading-relaxed">{t.blurb}</p>
              <div className="text-xs uppercase tracking-widest text-ink-muted mt-4">
                {t.defaults?.duration_target}s · {t.defaults?.tone}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12"><Link to="/register" className="brutal-btn">Use a template — sign up free</Link></div>
      </section>
    </MarketingLayout>
  );
}
